const modalMixin = {
  emits: ['close'],
};

export default modalMixin;
